module.exports = __webpack_public_path__ + "img/min_2.d91f28ee.png";